import React, { useEffect, useState } from 'react'
import FamilyHealthHistory from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/History/Components/FamilyHealthHistory/FamilyHealthHistory'
import SocialHistorySection from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/History/Components/SocialHistorySection/SocialHistorySection'
import PastMedicalHistory from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/History/Components/PastMedicalHistory/PastMedicalHistory'
import { useSelector } from 'react-redux'
import { ServerRequestProtected } from '../../../../../../utils/ServerDataRequest'
import { enumUtil } from '../../../../../../utils/Enum'
import isNull from '../../../../../../utils/NullChecking'
import { FindFirstChild } from '../../../../../../utils/FindMenuOption'

const History = (props) => {
  let { patientID } = props;
  
  //================== Clinical Summary ===================//

  let isViewAllowed = FindFirstChild('Patient', 'Encounter')?.ISView ?? true;
  let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd ?? true;
  let IsDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted ?? true;
  const API_URL = enumUtil.controller.PatientEncounter
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({})
  const [isRecordSaved, setIsRecordSaved] = useState(false)

  const LoadData = () => {
    setData([])
    setIsRecordSaved(false);
    setIsLoading(true);
    ServerRequestProtected(API_URL + "/GetPatientHistory", 'post', {
      "ID" : patientID,
      "TableName": enumUtil.enumAPITableName.PatientHistory,
    })
    .then((response) => {
        setIsLoading(false);
        setData(response)
    }).catch((error) => {
        setIsLoading(false);
    })
  }

  useEffect(()=>{
    LoadData();
  },[isRecordSaved])
    
  useEffect(() => {
    console.log("prop reload Encounter History")
    if (!isNull(props.Reload)) {
      let data = props.id
      data.map((item) => {
        if (item.key === 218) {
          LoadData()
        }
      })
      if (data.length === 0) {
        LoadData()
      }
    }
  }, [props.Reload])
    return (
        <>

            <div className="C_Head p-1 ">
                <p className="heading">HISTORY</p>
            </div>
            <div className="ar_encounter_main_screen ">
                <div className=" encounter_summary">
                    <div className="encounter_summary-content hover-scrollbar">
                        <div className="encounters-tabs d-flex flex-column gap-2">
                            <PastMedicalHistory expandAll ={true} data={data?.PastMedicalHistory} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>

                            <SocialHistorySection expandAll ={true} data={data?.SocialHistory} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>

                            <FamilyHealthHistory expandAll ={true} data={data?.FamilyHealthHistory?.FamilyHealthHistory} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default History